import React from 'react';
import PropTypes from 'prop-types';
import { 
  CardMedia, 
  Typography, 
  Box,
  Tooltip 
} from '@mui/material';
import PublicIcon from '@mui/icons-material/Public';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { getEntityImageUrl } from '../../../../api/utils';
import { defaultVenueImage } from '../../../../assets/images/defaults';
import {
  StyledCard,
  StatusBadge,
  PendingBookingsBadge,
  ImageContainer
} from './styled';

const VenueListItem = ({ venue, selectVenue }) => {
  const handleImageRenderError = (e) => {
    e.target.src = defaultVenueImage;
  };

  const pendingCount = venue?.pending_confirmations?.length || 0;

  return (
    <Box onClick={() => selectVenue(venue)} sx={{ cursor: 'pointer', p: 1 }}>
      <StyledCard>
        {venue?.status === 'AC' && (
          <StatusBadge>
            <PublicIcon sx={{ fontSize: 16 }} />
            Active
          </StatusBadge>
        )}
        
        <ImageContainer>
          <CardMedia
            component="img"
            src={getEntityImageUrl(venue, 'thumbnail', defaultVenueImage)}
            alt={venue?.name}
            onError={handleImageRenderError}
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </ImageContainer>

        <Box sx={{ p: 2, pb: 3 }}>
          <Typography 
            variant="h6" 
            sx={{ 
              fontSize: '1.1rem',
              fontWeight: 500,
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap'
            }}
          >
            {venue?.name}
          </Typography>
        </Box>

        {pendingCount > 0 && (
          <Tooltip title={`${pendingCount} pending booking${pendingCount > 1 ? 's' : ''} to confirm`}>
            <PendingBookingsBadge badgeContent={pendingCount}>
              <NotificationsActiveIcon color="action" />
            </PendingBookingsBadge>
          </Tooltip>
        )}
      </StyledCard>
    </Box>
  );
};

VenueListItem.propTypes = {
  venue: PropTypes.object,
  selectVenue: PropTypes.func,
};

export default VenueListItem;